import { __decorate, __param } from 'tslib';
import { InjectionToken, Inject, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HISTORY } from '@ng-web-apis/common';
import { TUI_PARENT_ANIMATION } from '@taiga-ui/cdk/constants';
import { TUI_DIALOGS } from '@taiga-ui/cdk/tokens';
import { of, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { TuiLetModule } from '@taiga-ui/cdk/directives';
import { TuiFocusTrapModule } from '@taiga-ui/cdk/directives/focus-trap';
import { TuiOverscrollModule } from '@taiga-ui/cdk/directives/overscroll';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@taiga-ui/cdk/directives';
import * as ɵngcc3 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc4 from '@taiga-ui/cdk/directives/focus-trap';
import * as ɵngcc5 from '@taiga-ui/cdk/directives/overscroll';
import * as ɵngcc6 from 'rxjs';
import * as ɵngcc7 from '@angular/platform-browser';

function TuiDialogHostComponent_ng_container_0_section_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "section", 3);
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("@tuiParentAnimation", undefined)("content", item_r4.component)("context", item_r4);
    ɵngcc0.ɵɵattribute("aria-labelledby", item_r4.id);
} }
function TuiDialogHostComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("popstate", function TuiDialogHostComponent_ng_container_0_div_2_Template_div_popstate_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const isDialogClosesOnBack_r5 = restoredCtx.tuiLet; const dialogs_r1 = ɵngcc0.ɵɵnextContext().ngIf; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.closeLast(dialogs_r1, isDialogClosesOnBack_r5); }, false, ɵngcc0.ɵɵresolveWindow)("transitionend", function TuiDialogHostComponent_ng_container_0_div_2_Template_div_transitionend_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const isDialogClosesOnBack_r5 = restoredCtx.tuiLet; const dialogs_r1 = ɵngcc0.ɵɵnextContext().ngIf; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.onDialog($event, !!dialogs_r1.length, isDialogClosesOnBack_r5); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const dialogs_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵclassProp("overlay_visible", dialogs_r1.length);
} }
function TuiDialogHostComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiDialogHostComponent_ng_container_0_section_1_Template, 1, 4, "section", 1);
    ɵngcc0.ɵɵtemplate(2, TuiDialogHostComponent_ng_container_0_div_2_Template, 1, 2, "div", 2);
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const dialogs_r1 = ctx.ngIf;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", dialogs_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tuiLet", ɵngcc0.ɵɵpipeBind1(3, 2, ctx_r0.isDialogClosesOnBack$));
} }
const TUI_DIALOG_CLOSES_ON_BACK = new InjectionToken('Is closing dialog on browser backward navigation enabled', {
    factory: () => of(false),
});
// TODO: remove in ivy compilation
const FAKE_HISTORY_STATE = { label: 'ignoreMe' };
// TODO: remove in ivy compilation
const isFakeHistoryState = (historyState) => (historyState === null || historyState === void 0 ? void 0 : historyState.label) === FAKE_HISTORY_STATE.label;
// @dynamic
let TuiDialogHostComponent = class TuiDialogHostComponent {
    constructor(isDialogClosesOnBack$, dialogsByType, historyRef, titleService) {
        this.isDialogClosesOnBack$ = isDialogClosesOnBack$;
        this.dialogsByType = dialogsByType;
        this.historyRef = historyRef;
        this.titleService = titleService;
        this.dialogs$ = combineLatest(this.dialogsByType).pipe(map(allTypesDialogs => new Array()
            .concat(...allTypesDialogs)
            .sort((a, b) => a.createdAt - b.createdAt)));
    }
    closeLast(dialogs, isDialogClosesOnBack) {
        if (!isDialogClosesOnBack) {
            return;
        }
        const [last] = dialogs.slice(-1);
        if (!last) {
            return;
        }
        if (dialogs.length > 1) {
            this.historyRef.pushState(FAKE_HISTORY_STATE, this.titleService.getTitle());
        }
        last.$implicit.complete();
    }
    onDialog({ propertyName }, popupOpened, isDialogClosesOnBack) {
        if (!isDialogClosesOnBack || propertyName !== 'letter-spacing') {
            return;
        }
        if (popupOpened) {
            this.historyRef.pushState(FAKE_HISTORY_STATE, this.titleService.getTitle());
        }
        else if (isFakeHistoryState(this.historyRef.state)) {
            this.historyRef.back();
        }
    }
};
TuiDialogHostComponent.ɵfac = function TuiDialogHostComponent_Factory(t) { return new (t || TuiDialogHostComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_DIALOG_CLOSES_ON_BACK), ɵngcc0.ɵɵdirectiveInject(TUI_DIALOGS), ɵngcc0.ɵɵdirectiveInject(HISTORY), ɵngcc0.ɵɵdirectiveInject(Title)); };
TuiDialogHostComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDialogHostComponent, selectors: [["tui-dialog-host"]], decls: 2, vars: 3, consts: [[4, "ngIf"], ["polymorpheus-outlet", "", "tuiFocusTrap", "", "tuiScrollRef", "", "tuiOverscroll", "all", "role", "dialog", "aria-modal", "true", "class", "dialog", 3, "content", "context", 4, "ngFor", "ngForOf"], ["class", "overlay", 3, "overlay_visible", "popstate", "transitionend", 4, "tuiLet"], ["polymorpheus-outlet", "", "tuiFocusTrap", "", "tuiScrollRef", "", "tuiOverscroll", "all", "role", "dialog", "aria-modal", "true", 1, "dialog", 3, "content", "context"], [1, "overlay", 3, "popstate", "transitionend"]], template: function TuiDialogHostComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiDialogHostComponent_ng_container_0_Template, 4, 4, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.dialogs$));
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc2.TuiLetDirective, ɵngcc3.PolymorpheusOutletComponent, ɵngcc4.TuiFocusTrapDirective, ɵngcc5.TuiOverscrollDirective], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{position:fixed;left:0;bottom:0;width:100%;height:0}.dialog[_ngcontent-%COMP%], .overlay[_ngcontent-%COMP%]{position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:flex-start;outline:0;overflow:auto;overflow:overlay}.dialog[_ngcontent-%COMP%]{bottom:auto;height:100%}.overlay[_ngcontent-%COMP%]{height:100vh;pointer-events:none;touch-action:none;opacity:0;letter-spacing:normal;transition:opacity var(--tui-duration),letter-spacing 10ms;background:rgba(0,0,0,.75)}.overlay_visible[_ngcontent-%COMP%]{opacity:1;letter-spacing:1px}.dialog[_ngcontent-%COMP%]:last-of-type{z-index:1}"], data: { animation: [TUI_PARENT_ANIMATION] }, changeDetection: 0 });
TuiDialogHostComponent.ctorParameters = () => [
    { type: Observable, decorators: [{ type: Inject, args: [TUI_DIALOG_CLOSES_ON_BACK,] }] },
    { type: Array, decorators: [{ type: Inject, args: [TUI_DIALOGS,] }] },
    { type: History, decorators: [{ type: Inject, args: [HISTORY,] }] },
    { type: Title, decorators: [{ type: Inject, args: [Title,] }] }
];
TuiDialogHostComponent = __decorate([ __param(0, Inject(TUI_DIALOG_CLOSES_ON_BACK)),
    __param(1, Inject(TUI_DIALOGS)),
    __param(2, Inject(HISTORY)),
    __param(3, Inject(Title))
], TuiDialogHostComponent);

let TuiDialogHostModule = class TuiDialogHostModule {
};
TuiDialogHostModule.ɵfac = function TuiDialogHostModule_Factory(t) { return new (t || TuiDialogHostModule)(); };
TuiDialogHostModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDialogHostModule });
TuiDialogHostModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            PolymorpheusModule,
            TuiOverscrollModule,
            TuiFocusTrapModule,
            TuiLetModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogHostComponent, [{
        type: Component,
        args: [{
                selector: 'tui-dialog-host',
                template: "<ng-container *ngIf=\"dialogs$ | async as dialogs\">\n    <section\n        *ngFor=\"let item of dialogs\"\n        polymorpheus-outlet\n        tuiFocusTrap\n        tuiScrollRef\n        tuiOverscroll=\"all\"\n        role=\"dialog\"\n        aria-modal=\"true\"\n        class=\"dialog\"\n        @tuiParentAnimation\n        [attr.aria-labelledby]=\"item.id\"\n        [content]=\"item.component\"\n        [context]=\"item\"\n    ></section>\n    <div\n        *tuiLet=\"isDialogClosesOnBack$ | async as isDialogClosesOnBack\"\n        class=\"overlay\"\n        [class.overlay_visible]=\"dialogs.length\"\n        (window:popstate)=\"closeLast(dialogs, isDialogClosesOnBack)\"\n        (transitionend)=\"onDialog($event, !!dialogs.length, isDialogClosesOnBack)\"\n    ></div>\n</ng-container>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                animations: [TUI_PARENT_ANIMATION],
                styles: [":host{position:fixed;left:0;bottom:0;width:100%;height:0}.dialog,.overlay{position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:flex-start;outline:0;overflow:auto;overflow:overlay}.dialog{bottom:auto;height:100%}.overlay{height:100vh;pointer-events:none;touch-action:none;opacity:0;letter-spacing:normal;transition:opacity var(--tui-duration),letter-spacing 10ms;background:rgba(0,0,0,.75)}.overlay_visible{opacity:1;letter-spacing:1px}.dialog:last-of-type{z-index:1}"]
            }]
    }], function () { return [{ type: ɵngcc6.Observable, decorators: [{
                type: Inject,
                args: [TUI_DIALOG_CLOSES_ON_BACK]
            }] }, { type: Array, decorators: [{
                type: Inject,
                args: [TUI_DIALOGS]
            }] }, { type: History, decorators: [{
                type: Inject,
                args: [HISTORY]
            }] }, { type: ɵngcc7.Title, decorators: [{
                type: Inject,
                args: [Title]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogHostModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    PolymorpheusModule,
                    TuiOverscrollModule,
                    TuiFocusTrapModule,
                    TuiLetModule,
                ],
                declarations: [TuiDialogHostComponent],
                exports: [TuiDialogHostComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDialogHostModule, { declarations: function () { return [TuiDialogHostComponent]; }, imports: function () { return [CommonModule,
        PolymorpheusModule,
        TuiOverscrollModule,
        TuiFocusTrapModule,
        TuiLetModule]; }, exports: function () { return [TuiDialogHostComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { FAKE_HISTORY_STATE, TUI_DIALOG_CLOSES_ON_BACK, TuiDialogHostComponent, TuiDialogHostModule, isFakeHistoryState };

